import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { FilterChip } from "../../FilterChip";
import { DEPENDENT_CATEGORIES, PREREQUISITE_CATEGORIES } from "../constants";

export function StepDrinkCategories({ categories, answers, setAnswers }) {
  const selected = answers.drink_categories;
  const hasPrerequisite = selected.some((k) => PREREQUISITE_CATEGORIES.includes(k));

  function toggle(key) {
    setAnswers((prev) => {
      const isSelected = prev.drink_categories.includes(key);
      const next = isSelected
        ? prev.drink_categories.filter((k) => k !== key)
        : [...prev.drink_categories, key];
      return { ...prev, drink_categories: next };
    });
  }

  return (
    <Box>
      <Text fontSize={{ base: "17px", md: "20px" }} fontWeight="900" color="#004a33" mb="3px">
        Quais bebidas você quer no seu evento?
      </Text>
      <Text fontSize="12px" color="gray.500" mb="12px">
        Escolha quantas quiser — a Boozen calcula a proporção certa de cada uma.
      </Text>

      <SimpleGrid columns={{ base: 3, sm: 4, md: 5 }} spacing="6px" mb="8px">
        {categories.map((c) => {
          const isDisabled = DEPENDENT_CATEGORIES.includes(c.key) && !hasPrerequisite;
          return (
            <Box
              key={c.key}
              opacity={isDisabled ? 0.4 : 1}
              pointerEvents={isDisabled ? "none" : "auto"}
            >
              <FilterChip
                label={c.label}
                isActive={selected.includes(c.key)}
                onClick={() => toggle(c.key)}
              />
            </Box>
          );
        })}
      </SimpleGrid>

      {!hasPrerequisite && (
        <Text fontSize="11px" color="gray.500">
          Espuma e Xarope ficam disponíveis ao selecionar Gin, Vodka ou Cachaça.
        </Text>
      )}
    </Box>
  );
}
